import { safetyHandler } from '../../../../../../../enums/utils';

export const TileType = new Proxy(
  {
    TEXT: 'text',
    IMAGE: 'image',
  },
  safetyHandler('TileType'),
);
